import React from "react";
import { HiPlus, HiSparkles } from "react-icons/hi";
import { UseAgentTestLab } from "./useAgentTestLab";

interface EmptyScenariosProps {
  lab: UseAgentTestLab;
}

export const EmptyScenarios: React.FC<EmptyScenariosProps> = ({ lab }) => (
  <div className="flex items-center justify-center min-h-[480px] p-8">
    <div className="max-w-md w-full text-center space-y-5">
      <div className="mx-auto h-14 w-14 rounded-full bg-[var(--accent)]/10 text-[var(--accent)] flex items-center justify-center">
        <HiSparkles className="w-7 h-7" />
      </div>
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-[var(--foreground)]">
          Baseline this agent in a few minutes
        </h3>
        <p className="text-sm text-[var(--foreground-muted)]">
          Generate a set of QA scenarios — happy paths, edge cases, bad-faith
          users, and language switches — and run them against the current
          prompt to find failures before users do.
        </p>
      </div>
      <ul className="text-sm text-left text-[var(--foreground-muted)] space-y-1.5 max-w-sm mx-auto">
        <li className="flex gap-2">
          <span className="text-[var(--accent)]">•</span>
          Starts with 6 focused scenarios across personas
        </li>
        <li className="flex gap-2">
          <span className="text-[var(--accent)]">•</span>
          Runs each one and scores against your pass criteria
        </li>
        <li className="flex gap-2">
          <span className="text-[var(--accent)]">•</span>
          Suggests prompt edits when failures cluster
        </li>
      </ul>
      <div className="flex items-center justify-center gap-2 pt-1">
        <button
          type="button"
          onClick={lab.handleGenerateScenarios}
          disabled={lab.isGenerating}
          className="px-4 py-2 bg-[var(--accent)] text-[var(--accent-foreground)] rounded-md hover:bg-[var(--accent-hover)] disabled:opacity-50 inline-flex items-center gap-2 text-sm font-medium"
        >
          <HiSparkles className="w-4 h-4" />
          {lab.isGenerating ? "Generating…" : "Generate first scenarios"}
        </button>
        <button
          type="button"
          onClick={lab.handleAddScenario}
          className="px-3 py-2 text-sm rounded-md text-[var(--foreground-muted)] hover:text-[var(--foreground)] hover:bg-[var(--muted)] inline-flex items-center gap-2"
        >
          <HiPlus className="w-4 h-4" />
          Add manually
        </button>
      </div>
    </div>
  </div>
);
